export enum RESELLER_CONSOLE {
    /**
     * @value Force login for all users from this source, using their source credentials.
     */
    AUTO_SYNC_HELPER = 'ADMIN.RESELLER_CONSOLE.ONLY_AUTO_AUTH_SOURCE_HELPER',
    /**
     * @value Automatic login
     */
    AUTO_SYNC_LABEL = 'ADMIN.RESELLER_CONSOLE.ONLY_AUTO_AUTH_SOURCE',
    /**
     * @value Cell
     */
    CELL = 'CELL',
    /**
     * @value Classic
     * @description Account type option in the reseller console, as opposed to external
     */
    CLASSIC = 'RESELLER_CONSOLE.CLASSIC',
    /**
     * @value Customer
     * @description A placeholder key that will be reused whenever we reference the word 'Customer' on its own.
     */
    CUSTOMER = 'GLOBAL.CUSTOMER',
    /**
     * @value External directory url
     */
    CUSTOMER_EXTERNAL_DIRECTORY = 'RESELLER_CONSOLE.CUSTOMER_EXTERNAL_DIRECTORY',
    /**
     * @value Customer id
     */
    CUSTOMER_ID = 'ADMIN_CUSTOMER_ID',
    /**
     * @value This customer is a reseller
     */
    CUSTOMER_IS_RESELLER = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_IS_RESELLER',
    /**
     * @value License expiration date
     */
    CUSTOMER_LICENSE_EXPIRATION_DATE = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_LICENSE_EXPIRATION_DATE',
    /**
     * @value Licenses number
     */
    CUSTOMER_LICENSE_NUMBER = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_LICENSE_NUMBER',
    /**
     * @value Customer name
     */
    CUSTOMER_NAME = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_NAME',
    /**
     * @value Users number
     */
    CUSTOMER_NB_USERS = 'RESELLER_CONSOLE.CUSTOMER_NB_USERS',
    /**
     * @value Customer saved
     * @description Confirmation message shown after saving a customer in the reseller console
     */
    CUSTOMER_SAVED = 'RESELLER_CONSOLE.CUSTOMER_SAVED',
    /**
     * @value Customer settings
     */
    CUSTOMER_SETTINGS = 'RESELLER_CONSOLE.CUSTOMER_SETTINGS',
    /**
     * @value Organization name used in URL
     */
    CUSTOMER_SLUG = 'ADMIN_CUSTOMER_PLATFORM_SLUG',
    /**
     * @value Trusted tester
     */
    CUSTOMER_TRUSTED_TESTER = 'RESELLER_CONSOLE.CUSTOMER_TRUSTED_TESTER',
    /**
     * @value Trusted testers will gain access to new features before they're made public to all customers.
     */
    CUSTOMER_TRUSTED_TESTER_HELPER = 'RESELLER_CONSOLE.CUSTOMER_TRUSTED_TESTER_HELPER',
    /**
     * @value External
     */
    EXTERNAL = 'ADMIN.ACCOUNT_TYPE.EXTERNAL',
    /**
     * @value Feature packages
     */
    FEATURE_PACKAGES = 'RESELLER_CONSOLE.FEATURE_PACKAGES',
    /**
     * @value Google Cloud Identity Source ID
     */
    GOOGLE_CLOUD_IDENTITY_SOURCE_ID = 'RESELLER_CONSOLE.GOOGLE_CLOUD_IDENTITY_SOURCE_ID',
    /**
     * @value Instances overrides
     */
    INSTANCES_OVERRIDES = 'RESELLER_CONSOLE.INSTANCES_OVERRIDES',
    /**
     * @value Instances settings
     */
    INSTANCE_SETTINGS = 'RESELLER_CONSOLE.INSTANCE_SETTINGS',
    /**
     * @value Instances themes
     */
    INSTANCE_THEMES = 'RESELLER_CONSOLE.INSTANCE_THEMES',
    /**
     * @value License
     */
    LICENSE = 'RESELLER_CONSOLE.LICENSE',
    /**
     * @value License is expired
     */
    LICENSE_EXPIRED = 'RESELLER_CONSOLE.LICENSE_EXPIRED',
    /**
     * @value Maximum number of users reached
     */
    LICENSE_OVER_QUOTA = 'ADMIN_RESELLER_CONSOLE_LICENSE_OVER_QUOTA',
    /**
     * @value No description available.
     */
    NO_DESCRIPTION_AVAILABLE = 'RESELLER_CONSOLE.NO_DESCRIPTION_AVAILABLE',
    /**
     * @value Override name
     */
    OVERRIDE_NAME = 'RESELLER_CONSOLE.OVERRIDE_NAME',
    /**
     * @value Providers
     */
    PROVIDERS = 'ADMIN.RESELLER_CONSOLE.PROVIDERS',
    /**
     * @value G Suite
     * @description Registration link label for the Google provider
     */
    REGISTRATION_LINK_GOOGLE = 'RESELLER_CONSOLE.REGISTRATION_LINK_GOOGLE',
    /**
     * @value Reseller
     */
    RESELLER = 'ADMIN_RESELLER_CONSOLE_TAB_RESELLER',
    /**
     * @value Reseller console
     */
    RESELLER_CONSOLE = 'RESELLER_CONSOLE.RESELLER_CONSOLE',
    /**
     * @value Setting name
     */
    SETTING_NAME = 'RESELLER_CONSOLE.SETTING_NAME',
    /**
     * @value Theme name
     */
    THEME_NAME = 'RESELLER_CONSOLE.THEME_NAME',
}
